import { Dispatch, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { SortBuilder } from "~/components/SortBuilder"
import { FindProductsCustomFieldsRequestSortsDto } from "~/gen/api"

interface Props {
  sorts: FindProductsCustomFieldsRequestSortsDto
  setSorts: Dispatch<SetStateAction<FindProductsCustomFieldsRequestSortsDto>>
}

export const ProductCustomFieldsSorts = ({ sorts, setSorts }: Props) => {
  const { t } = useTranslation("products")

  return (
    <SortBuilder<FindProductsCustomFieldsRequestSortsDto>
      options={[
        { label: t("sorts.name"), value: "name" },
        { label: t("sorts.brandReference"), value: "brandReference" },
        { label: t("sorts.purchaseOrder"), value: "purchaseOrder" },
        { label: t("sorts.brand"), value: "brand" },
        { label: t("sorts.color"), value: "color" },
        { label: t("sorts.brandType"), value: "brandType" },
        { label: t("sorts.collection"), value: "collection" },
      ]}
      sorts={sorts}
      setSorts={setSorts}
    />
  )
}
